import { Box } from '@mui/material';
import PrimarySearchAppBar from '../components/PrimarySearchAppBar';
import { LandingPage } from '../pages/LandingPage';

export const HomePage = () => {
	return (
		<Box
			display='flex'
			flexDirection='column'
			width='100vw'
			height='100vh'
		>
			<PrimarySearchAppBar/>
			<LandingPage />
		</Box>
	);
};
